import { InputField } from '@hakimo-ui/shared/ui-base';
import clsx from 'clsx';
import { ChangeEvent } from 'react';
import { DisarmWindowFormValue, QUICK_OPTIONS } from './util';

interface Props {
  value: DisarmWindowFormValue;
  onChange: (value: DisarmWindowFormValue) => void;
  isArming?: boolean;
}

function ArmedStatusForm({ value, onChange, isArming }: Props) {
  const handleSelect = (type: 'quick' | 'custom', id?: string) => {
    const isActive =
      type === 'quick'
        ? value.quickDuration === id && value.activeInput === 'quick'
        : value.activeInput === 'custom';

    onChange(
      isActive
        ? {
            ...value,
            activeInput: null,
            quickDuration: null,
            startTime: '',
            endTime: '',
          }
        : {
            ...value,
            activeInput: type,
            quickDuration: id ?? null,
            startTime: '',
            endTime: '',
          }
    );
  };

  const handleTimeChange =
    (field: 'startTime' | 'endTime') => (e: ChangeEvent<HTMLInputElement>) =>
      onChange({
        ...value,
        [field]: e.target.value,
        activeInput: 'custom',
        quickDuration: null,
      });

  const optionClass = (active: boolean) =>
    clsx(
      'rounded-md border px-4 py-1.5 text-sm font-medium transition-colors',
      active
        ? 'border-blue-500 bg-blue-500 text-white'
        : 'border-onlight-line-3 text-ondark-text-3 dark:border-dark-border-surface dark:text-ondark-text-1'
    );

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <p className="text-onlight-text-2 dark:text-ondark-text-2 text-sm font-medium">
          {isArming ? 'Arm Options' : 'Disarm Options'}
        </p>
        <div className="flex flex-wrap gap-2">
          {QUICK_OPTIONS.map((opt) => (
            <button
              key={opt.id}
              type="button"
              onClick={() => handleSelect('quick', opt.id)}
              className={optionClass(
                value.quickDuration === opt.id && value.activeInput === 'quick'
              )}
            >
              {opt.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => handleSelect('custom')}
            className={optionClass(value.activeInput === 'custom')}
          >
            Custom Range
          </button>
        </div>
      </div>

      {value.activeInput === 'custom' && (
        <div className="space-y-4">
          <InputField
            type="datetime-local"
            label="Start Time"
            value={value.startTime}
            onChange={handleTimeChange('startTime')}
          />
          <InputField
            type="datetime-local"
            label="End Time"
            value={value.endTime}
            onChange={handleTimeChange('endTime')}
          />
        </div>
      )}
    </div>
  );
}

export default ArmedStatusForm;
